import { type AuthPrompt } from '@/context/auth/AuthPromptProvider';

import { SignupScreenProps } from '../shared/types';
import { CalmAccountQuestion } from './CalmAccountQuestion';
import { WelcomeContentWrapper } from './styles';

const Welcome = ({ compact, onScreenChange, partnerDetails }: SignupScreenProps) => {
	const { id, name, pageInfo } = partnerDetails;

	function onCtaClick(mode: AuthPrompt): void {
		onScreenChange('account', mode);
	}

	return (
		<WelcomeContentWrapper>
			<CalmAccountQuestion
				activationMessage={pageInfo.messages.activate}
				compact={compact}
				onCtaClick={onCtaClick}
				partnerId={id}
				partnerName={name}
				partnerDetails={partnerDetails}
			/>
		</WelcomeContentWrapper>
	);
};

export default Welcome;
